export default __webpack_public_path__ + "static/media/mercedesCup-dark.441370bd.svg";